import { post } from './base';
import type {
  BeneficiaryType,
  NamedCompanyOrCommunityBeneficiary,
  NamedPersonBeneficiary,
} from '../dto/beneficiary';
import { type CoveragePremium, type PremiumAmount } from 'dto/CoveragePremium';
import { type EditableFormValues } from 'individual/components/BackgroundInfo/EditableForm';
import { type BackgroundInfoForm } from 'individual/types/backgroundInfoForm';
import type { IndividualLifeForm } from 'individual/types/initialState';
import { toBackgroundInfoForm } from 'utils';

export async function calculateRating(
  productName: string,
  formValues: EditableFormValues
): Promise<{ coveragePremiums: CoveragePremium[] }> {
  const url = '/rating/' + productName;
  const body: BackgroundInfoForm = toBackgroundInfoForm(formValues);
  return await post(url, body);
}

export interface EstimatorRatingRequest {
  dateOfBirth: string;
  monthlyIncome: number;
}

export interface EstimatorPremium {
  insuranceDailyAllowance: number;
  insuranceMonthlyAllowance: number;
  waitingDays: number;
  monthlyPremium: PremiumAmount;
  annualPremium: PremiumAmount;
}

export interface EstimatorRatingResponse {
  kelaDailyAllowance: number;
  kelaMonthlyAllowance: number;
  premiums: EstimatorPremium[];
}

export async function calculateTemporaryDisabilityEstimate(
  request: EstimatorRatingRequest
): Promise<EstimatorRatingResponse> {
  const url = '/estimator/temporary-disability';
  return await post(url, request);
}

export interface ConfirmPurchaseRequest {
  calculatorInput: IndividualLifeForm;
  beneficiaryType: BeneficiaryType;
  beneficiaryMaritalRightsExcluded?: boolean;
  namedBeneficiaries?: Array<
    NamedPersonBeneficiary | NamedCompanyOrCommunityBeneficiary
  >;
  languageConfirmation?: boolean;
  consentForDocuments: boolean;
}

export interface ConfirmPurchaseResponse {
  accepted: boolean;
  policyNumber?: string;
  healthDeclarationId?: string;
  jobId?: string;
}

export async function confirmPurchase(
  request: ConfirmPurchaseRequest
): Promise<ConfirmPurchaseResponse> {
  const url = '/individual-life/confirm-purchase';
  return await post(url, request);
}

export async function encryptLifeForm(
  form: IndividualLifeForm
): Promise<{ encrypted: string }> {
  return await post('/individual-life/encrypt', form);
}
